import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { CommonDataService } from '../../services/common-data.service';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-account-email-verification',
  templateUrl: './account-email-verification.component.html',
  styleUrls: ['./account-email-verification.component.css']
})
export class AccountEmailVerificationComponent implements OnInit {

  pageName = "Email verification"
  btnText = "Resend Email"
  constructor(private _data: CommonDataService, private authService: AuthService, private router: Router) { }

  ngOnInit() {
  }

  resendVerificationEmail() {
    this.btnText = "Please wait..."
    let queryData = new FormData();
    queryData.append('forceResend', 'true');

    this._data.dynamicFormPost(queryData, "email-resend-verification-link") 
        .pipe(first())
        .subscribe(
          data => {
   
            //this.modelId = data['result']['id'];
            alert("The account verification email has been resend. Check your inbox and follow instructions to verify your account.")
            this.router.navigate(['/account/profile']);

          },
          error => {

            alert('Whooops, we experienced some issues sending your email, kindly contact support!')
            this.btnText = "Resend Email"

  
          },
  
          () => {
            this.btnText = "Resend Email"
  
          }
        );
  }

}
